import { DecimalPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Tab } from '../../model/tabs';

@Component({
  selector: 'app-search-hit-count',
  templateUrl: './search-hit-count.component.html',
  styleUrls: [ './search-hit-count.component.scss' ],
  imports: [ DecimalPipe ]
})
export class SearchHitCountComponent {
  @Input() total: number;
  @Input() tab: Tab;
  @Input() searchHasRun: boolean;
}
